// Shared game constants for Pinmonkey

export const GRID_SIZE = 48;

export const PLAYER_STRIDE = 10;

// Player movement
// SNAP_THRESHOLD must be GRID_SIZE-1 so the reactive snap can reach the
// correct tile alignment from any sub-tile offset (worst case: 19 px off).
export const SNAP_THRESHOLD = GRID_SIZE - 1; // px — max perpendicular snap to slip through a gap
export const ALIGN_THRESHOLD = GRID_SIZE / 2; // px — max grid-line pull when moving along an axis

// NPC interactive-tile approach
export const NPC_TRIGGER_RANGE = GRID_SIZE * 3; // player distance that starts approach
export const NPC_DIALOG_RANGE = GRID_SIZE * 1.5; // NPC distance to tile that starts dialog

// Monster AI — distances are center-to-center
export const MONSTER_CHASE_RANGE = GRID_SIZE * 6;   // ~6 tiles
export const MONSTER_BACK_OFF_RANGE = GRID_SIZE + 4; // just outside adjacent tile
export const MONSTER_DAMAGE_COOLDOWN = 150; // frames between damage ticks
export const MONSTER_CHASE_RECOMPUTE_INTERVAL = 45; // frames between A* recomputes
export const MONSTER_STUCK_THRESHOLD = 20; // frames before forcing path recompute

// NPC dialog actions
export const DIALOG_ACTION_SHOP = "shop";

// Quest step types
export const QUEST_STEP_COLLECT_ITEM = "collect_item";
export const QUEST_STEP_DELIVER_TO_NPC = "deliver_to_npc";
export const QUEST_STEP_PLACE_ON_TILE = "place_on_tile";

// XP awards
export const XP_NPC_DIALOG = 15;
export const XP_NEW_LEVEL = 25;
export const XP_NEW_DUNGEON = 50;
export const XP_MONSTER_MIN = 5;
export const XP_MONSTER_HP_DIVISOR = 3;

// Item types (used by editor and admin NPC form)
export const ITEM_TYPES = [
  { value: "gold", label: "Gold", color: "#FFD700" },
  { value: "food", label: "Food", color: "#66bb44" },
  { value: "treasure", label: "Treasure", color: "#e8a020" },
  { value: "weapon", label: "Weapon", color: "#88aacc" },
  { value: "armor", label: "Armor", color: "#cc9944" },
  { value: "potion", label: "Potion", color: "#cc44cc" },
];

// Backward compat alias
export const TREASURE_TYPES = ITEM_TYPES;

// Available character/NPC sprites (filename stem, e.g. "Cowboy" → /Sprites/Cowboy_0001.png)
export const DUNGEON_SPRITES = [
  "Cowboy",
  "Cowgirl",
  "Hula",
  "Mermaid",
  "Sailor",
];
export const DEFAULT_MONSTER_SPRITE = "Skeleton";
export const MONSTER_SPRITES = ["Skeleton", "Monkey", "Merman"];
export const spriteImagePath = (name) => `/Sprites/${name}_0001.png`;

// Inventory category limit: base 3 unique stacks, +1 per 500 XP
export const INVENTORY_LIMIT_BASE = 3;
export const INVENTORY_LIMIT_XP_STEP = 500;
export const getInventoryLimit = (xp) =>
  INVENTORY_LIMIT_BASE + Math.floor(xp / INVENTORY_LIMIT_XP_STEP);
